import styled from 'styled-components';

export const Container = styled.div`
  &.FaqSubitem{
    position: relative;
    padding: 32px 20px;
    @media screen and (max-width: 767px) {
      padding: 12px 20px;
    }
  }
  & .ItemSubTitle{
    cursor: pointer;
    color: ${props => props.theme.colors.primaryBlue};
    position: relative;
    
    @media screen and (max-width: 767px) {
      font-size: 16px;
    }
  }
  &.FaqSubitem:not(:first-child)::before{
    content: '';
    height: 1px;
    width: 110%;
    background-color: #DADFE6;
    position: absolute;
    left: -5%;
    top: 0;
  }
  &.FaqSubitemTextWrapper{
    position: relative;
  }
`;

export const StyledImg = styled.img`
  position: absolute;
  top: calc(50% - 6px);
  right: -15px;
  cursor: pointer;
`;

export const StyledH4 = styled.h4`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 152%;
  color: #1C62EF;
  width: 90%;
  word-break: break-word;
  position: relative;
`;

export const StyledParagraph = styled.div`
  font-family: OpenSans, sans-serif, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 168%;
  color: #808387;
  width: 90%;
  word-break: break-word;
  padding-top: 15px;
  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;